import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import LoginForm from "../views/LoginForm.vue";
import ForgotPassword from "../views/ForgotPassword.vue";
import TwoFactorChallenge from "../views/TwoFactorChallenge.vue";
import PerfilUsuario from "../views/PerfilUsuario.vue";
import EnviarTicket from "../views/sos/soporte/seguimientos/tickets/EnviarTicket.vue";
import store from "../store/index.js";
import { trafiguraPathRedirects } from "./trafiguraRoutes.js";
import {
  isPublicAuthRoute,
  isTwoFactorSetupAllowedRoute,
} from "../utils/authRoutes.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/LoginForm",
    name: "LoginForm",
    component: LoginForm,
  },
  {
    path: "/ForgotPassword",
    name: "ForgotPassword",
    component: ForgotPassword,
  },
  {
    path: "/TwoFactorChallenge",
    name: "TwoFactorChallenge",
    component: TwoFactorChallenge,
  },
  {
    path: "/PerfilUsuario",
    name: "PerfilUsuario",
    component: PerfilUsuario,
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/EnviarTicket",
    name: "EnviarTicket",
    component: EnviarTicket,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const rep = trafiguraPathRedirects[to.path];
  if (rep) {
    next({ path: rep, replace: true });
    return;
  }
  if (
    to.query.plataforma === "trafigura" &&
    (to.path.includes("/Trafigura/") ||
      String(to.name || "").startsWith("/Trafigura/"))
  ) {
    const query = { ...to.query };
    delete query.plataforma;
    next({
      path: to.path,
      params: to.params,
      hash: to.hash,
      query,
      replace: true,
    });
    return;
  }
  if (!isPublicAuthRoute(to.name) && !store.getters.isAuthenticated) {
    next({ name: "LoginForm" });
    return;
  }
  // Sin ningún 2FA activo: solo puede estar en Mi perfil (u rutas públicas).
  if (
    store.getters.requiresTwoFactorSetup &&
    !isTwoFactorSetupAllowedRoute(to.name)
  ) {
    next({ name: "PerfilUsuario", replace: true });
    return;
  }
  next();
});

export default router;
